import Link from '@/_application/core/components/ui/link';
import {ArrowNextIcon} from '@/_application/icons/arrow-next';
import {Routes} from '@/config/routes';

interface IProps {
    viewAllLabel?: string;
}

function UsefulInformationHeader({viewAllLabel}: Readonly<IProps>) {
    return (
        <div className="flex items-center justify-between px-4 py-2 md:px-0 md:py-0">
            <h2 className="text-sm  font-extrabold leading-4 text-primary md:text-[22px] md:leading-[25px]">
                Thông tin bổ ích
            </h2>
            {viewAllLabel && (
                <a
                    target="_blank"
                    href={`${Routes.blog}`}
                    className="group flex items-center font-bold text-primary transition-colors hover:text-KPZ_turquoise">
                    <span className="text-xs leading-4 text-KPZ_turquoise md:text-base md:leading-[22px] md:text-primary">
                        {viewAllLabel}
                    </span>
                    <ArrowNextIcon className="mt-px hidden w-[7px] md:block ltr:ml-1.5 rtl:mr-1.5" />
                </a>
            )}
        </div>
    );
}

export default UsefulInformationHeader;
